import moment from "moment";

/**
 * Calculate granularity based on the date range
 * @param {string} startDate - Start date
 * @param {string} endDate - End date
 * @returns {string} - "Daily", "Weekly", or "Monthly"
 */
/**
 * Format energy value with compact notation (kWh / MWh)
 * @param {number|string} value - Energy value in kWh
 * @returns {{ displayValue: string, unit: string, divisor: number }}
 */
/**
 * Format a number into compact notation (1k, 10k, 1M, etc.)
 * @param {number} value - The number to format
 * @returns {string} - Formatted string
 */
export const formatCompactNumber = (value) => {
    const num = Number(value || 0);
    const abs = Math.abs(num);
    const sign = num < 0 ? '-' : '';
    if (abs >= 1_000_000) return `${sign}${parseFloat((abs / 1_000_000).toPrecision(3))}M`;
    if (abs >= 1_000) return `${sign}${parseFloat((abs / 1_000).toPrecision(3))}k`;
    return `${sign}${abs}`;
};

export const formatCompactEnergy = (value) => {
    const num = Number(value || 0);
    if (num >= 1_000) return { displayValue: Math.round(num / 1_000).toString(), unit: 'MWh', divisor: 1_000 };
    return { displayValue: Math.round(num).toString(), unit: 'kWh', divisor: 1 };
};

export const smartDecimal = (value, places = 2) => {
    if (value === undefined || value === null) return '-';
    return parseFloat(Number(value).toFixed(places)).toString();
};

export const calculateGranularity = (startDate, endDate) => {
    if (!startDate || !endDate) {
        return "Weekly";
    }
    const daysDiff = moment(endDate).diff(moment(startDate), "days") + 1;
    if (daysDiff <= 14) {
        return "Daily";
    } else if (daysDiff > 60) {
        return "Monthly";
    }
    return "Weekly";
};
